(() => {
  if (window.__iesCartCleanupFixV2) return;
  window.__iesCartCleanupFixV2 = true;

  const heatShippingMessage = 'Body Butter is local delivery only during excessive heat. Local delivery is available for eligible ZIP codes on orders $35+. Product may be temporarily unavailable for shipping until September 17.';

  const css = document.createElement('style');
  css.textContent = `
    .lux-cart-sale-badge,
    .lux-drawer-offer,
    .lux-drawer-discount-checkout,
    a[href*='FREEDOM20'],
    a[href*='freedom20'] { display:none!important; }
    .ies-cart-qty-message{
      display:block;
      margin:8px 0 0;
      color:#8b0000;
      font-size:12px;
      line-height:1.35;
      font-weight:800;
    }
    .lux-drawer-details .ies-cart-qty-message{font-size:11px;margin-top:7px;}
    .ies-heat-shipping-notice{
      display:block;
      margin:0 0 14px;
      padding:12px 13px;
      background:#fff4ef;
      border:1px solid #d98b78;
      color:#5b1b12;
      font-size:12px;
      line-height:1.45;
      font-weight:800;
    }
    .lux-drawer-inline-checkout .ies-heat-shipping-notice{margin-bottom:12px;}
  `;
  document.head.appendChild(css);

  function cleanFreedomText(){
    document.querySelectorAll('.lux-cart-sale-badge,.lux-drawer-offer,.lux-drawer-discount-checkout').forEach(el=>el.remove());
    document.querySelectorAll('a[href*="FREEDOM20"],a[href*="freedom20"]').forEach(el=>{ if(el.closest('.lux-cart-summary')||el.closest('.lux-drawer-inline-checkout')) el.remove(); });
  }

  function cleanFreeGiftText(){
    document.querySelectorAll('.lux-secure-strip span,.ies-jte-freegift,[class*="gift"],[class*="Gift"],[class*="promo"],[class*="Promo"],p,span,div,a,button').forEach(el => {
      if (!el || el.children.length > 3) return;
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (!text) return;
      const mentionsFreeGift = text.includes('free gift') || text.includes('free obsession body spray');
      const matchesOffer = text.includes('$60') || text.includes('orders $60') || text.includes('while supplies last') || text.includes('body spray on orders');
      if (mentionsFreeGift && matchesOffer) el.remove();
    });
  }

  function cartHasBodyButter(){
    return Array.from(document.querySelectorAll('.lux-cart-item__title,.lux-drawer-title,.cart-item__title')).some(el => {
      const title = el.textContent.trim().toLowerCase();
      return title === 'body butter' || title.startsWith('body butter -');
    });
  }

  function ensureHeatNotice(container){
    if(!container) return;
    if(container.querySelector('.ies-heat-shipping-notice')) return;
    const notice = document.createElement('p');
    notice.className = 'ies-heat-shipping-notice';
    notice.setAttribute('role', 'note');
    notice.textContent = heatShippingMessage;
    container.prepend(notice);
  }

  function syncExistingHeatText(){
    document.querySelectorAll('.lux-product-heat-note,.checkout-heat-notice,.ies-heat-shipping-notice').forEach(el => {
      el.textContent = heatShippingMessage;
    });
  }

  function syncHeatNotice(){
    syncExistingHeatText();
    const hasBodyButter = cartHasBodyButter();
    if(!hasBodyButter){
      document.querySelectorAll('.ies-heat-shipping-notice').forEach(el => el.remove());
      return;
    }
    ensureHeatNotice(document.querySelector('.lux-cart-summary'));
    ensureHeatNotice(document.querySelector('.lux-drawer-inline-checkout'));
    syncExistingHeatText();
  }

  function refreshCartMessaging(){
    cleanFreedomText();
    cleanFreeGiftText();
    syncHeatNotice();
  }

  function qtyWrap(input){ return input?.closest('.lux-cart-item__details,.lux-drawer-details,.lux-cart-item,.lux-drawer-row'); }
  function qtyMessage(input, text){
    const wrap = qtyWrap(input);
    if(!wrap) return;
    let msg = wrap.querySelector('.ies-cart-qty-message');
    if(!msg){
      msg = document.createElement('p');
      msg.className = 'ies-cart-qty-message';
      const controls = input.closest('.lux-cart-item__controls,.lux-drawer-controls,.lux-cart-quantity,.lux-drawer-qty');
      if(controls) controls.insertAdjacentElement('afterend', msg); else wrap.appendChild(msg);
    }
    msg.textContent = text || '';
    msg.hidden = !text;
  }
  function friendlyError(raw, fallback){
    const text = String(raw || '').trim();
    if(/available|stock|inventory|quantity|sold/i.test(text)) return text;
    return fallback || 'We adjusted the quantity because that is all we have available right now.';
  }
  function getLineFromInput(input){
    if(!input) return null;
    if(input.dataset.index) return Number(input.dataset.index);
    const cartItem = input.closest('.lux-cart-item');
    if(cartItem) return Array.from(document.querySelectorAll('.lux-cart-item')).indexOf(cartItem)+1;
    const drawerItem = input.closest('.lux-drawer-row');
    if(drawerItem) return Array.from(document.querySelectorAll('.lux-drawer-row')).indexOf(drawerItem)+1;
    return null;
  }
  function refreshDrawer(){
    return fetch((window.routes?.cart_url||'/cart')+'?section_id=cart-drawer',{credentials:'same-origin'})
      .then(r=>r.text()).then(htmlText=>{
        const html = new DOMParser().parseFromString(htmlText,'text/html');
        const freshInner = html.querySelector('#CartDrawer .drawer__inner');
        const currentInner = document.querySelector('#CartDrawer .drawer__inner');
        if(freshInner&&currentInner) currentInner.innerHTML = freshInner.innerHTML;
        refreshCartMessaging();
      });
  }
  function refreshCartPage(){ window.location.reload(); }
  function updateCartLine(input, line, requestedQty, source, previousQty){
    const maxAttr = input?.getAttribute('max');
    const max = maxAttr ? Number(maxAttr) : 0;
    if(max && max < 999 && requestedQty > max){
      input.value = max;
      qtyMessage(input, `Only ${max} available for this item. We adjusted the quantity back to ${max}.`);
      return Promise.resolve();
    }
    qtyMessage(input, '');
    return fetch((window.routes?.cart_change_url||'/cart/change.js'),{
      method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({ line:Number(line), quantity:Math.max(0,Number(requestedQty||0)) })
    }).then(res=>res.json()).then(cart=>{
      if(cart && cart.errors){
        input.value = previousQty;
        qtyMessage(input, friendlyError(cart.errors, `We adjusted the quantity back to ${previousQty} because only that amount is available.`));
        return;
      }
      const updated = cart?.items?.[Number(line)-1]?.quantity;
      if(typeof updated === 'number' && updated !== Number(requestedQty)){
        input.value = updated;
        qtyMessage(input, `Only ${updated} available for this item. We adjusted the quantity back to ${updated}.`);
        return;
      }
      if(source === 'cart-page') refreshCartPage(); else refreshDrawer();
    }).catch(()=>{
      input.value = previousQty;
      qtyMessage(input, 'We adjusted the quantity because that amount is not available right now.');
    });
  }

  document.addEventListener('click', function(event){
    const cartMinus = event.target.closest('.lux-cart-quantity [data-cart-minus]');
    const cartPlus = event.target.closest('.lux-cart-quantity [data-cart-plus]');
    if(cartMinus || cartPlus){
      const box = event.target.closest('.lux-cart-quantity');
      const input = box?.querySelector('input[name="updates[]"]');
      if(!input) return;
      event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation?.();
      const current = Number(input.value||0);
      const next = cartPlus ? current+1 : Math.max(0,current-1);
      input.value = next;
      updateCartLine(input, getLineFromInput(input), next, 'cart-page', current);
      return;
    }
    const drawerButton = event.target.closest('.lux-drawer-qty .quantity__button');
    if(drawerButton){
      const box = drawerButton.closest('.lux-drawer-qty');
      const input = box?.querySelector('input.quantity__input');
      if(!input) return;
      event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation?.();
      const current = Number(input.value||0);
      const next = drawerButton.name === 'plus' ? current+1 : Math.max(0,current-1);
      input.value = next;
      updateCartLine(input, getLineFromInput(input), next, 'drawer', current);
      return;
    }
    const checkout = event.target.closest('.lux-cart-checkout,.lux-drawer-checkout,.cart__checkout-button,button[name="checkout"],input[name="checkout"]');
    if(checkout && !checkout.disabled){
      event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation?.();
      checkout.setAttribute('aria-busy','true'); if('disabled' in checkout) checkout.disabled=true;
      window.location.href='/checkout';
    }
  }, true);

  document.addEventListener('change', function(event){
    const input = event.target.closest('.lux-cart-quantity input[name="updates[]"], .lux-drawer-qty input.quantity__input');
    if(!input) return;
    const currentValue = Number(input.getAttribute('value') || input.defaultValue || 1);
    const requested = Math.max(0, Number(input.value || 0));
    const source = input.closest('.lux-cart-quantity') ? 'cart-page' : 'drawer';
    updateCartLine(input, getLineFromInput(input), requested, source, currentValue);
  }, true);

  document.addEventListener('submit', function(event){
    const form = event.target;
    if(!form || !form.querySelector || !form.querySelector('[name="checkout"]')) return;
    const submitter = event.submitter;
    if(submitter && submitter.name === 'update') return;
    event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation?.();
    window.location.href='/checkout';
  }, true);

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', refreshCartMessaging); else refreshCartMessaging();
  document.addEventListener('cart:updated', refreshCartMessaging);
  setInterval(refreshCartMessaging,1200);
})();